export default __webpack_public_path__ + "static/media/Genevieve_Leveille_AHV_In_Moms_We_Trust.b1de949a.jpg";